export const SET_NOTIFICATION = 'SET_NOTIFICATION';